export interface QuickTourStep {
  id: string;
  title: string;
  description: string;
  /** Element id to highlight */
  target: string;
  /** Optional path to navigate before showing this step */
  path?: string;
}

export const quickTourSteps: QuickTourStep[] = [
  {
    id: 'app-selector',
    title: 'Application Selector',
    description:
      'Switch between your WebRTC applications here. Each app has its own API keys, participants, settings, and analytics. Use “Create application” in this menu to add a new app.',
    target: 'tour-app-selector',
  },
  {
    id: 'active-plan',
    title: 'Active Plan',
    description:
      'Your current subscription plan is shown here. Click it anytime to open Plans & Billing, compare upgrades, and manage payment history.',
    target: 'tour-active-plan',
  },
  {
    id: 'account-menu',
    title: 'Account Menu',
    description:
      'Access profile settings, team members, billing, and support from your account avatar. You can also log out securely from this menu.',
    target: 'tour-account-menu',
  },
  {
    id: 'nav-home',
    title: 'Home',
    description:
      'Your starting hub. View onboarding action cards (create app, set up keysets, add participants) and a quick analytics overview of users and groups.',
    target: 'tour-nav-home',
    path: '/home',
  },
  {
    id: 'nav-dashboard',
    title: 'Dashboard',
    description:
      'Explore call, chat, and user analytics with interactive charts. Filter by date ranges and compare metrics to understand product usage.',
    target: 'tour-nav-dashboard',
  },
  {
    id: 'nav-settings',
    title: 'Application Settings',
    description:
      'Configure general app details, theme, security, data privacy, and advanced options. Keep these settings aligned with your production requirements.',
    target: 'tour-nav-settings',
  },
  {
    id: 'nav-api-keys',
    title: 'Apps & Keysets',
    description:
      'Create and manage API keysets used by your client SDKs. Keep keys secure and rotate them when needed for production and staging environments.',
    target: 'tour-nav-api-keys',
  },
  {
    id: 'nav-members',
    title: 'Members',
    description:
      'Invite teammates and assign roles (Admin, Developer, etc.). Role-based access controls what each member can view or change in the dashboard.',
    target: 'tour-nav-members',
  },
  {
    id: 'nav-participants',
    title: 'Participants',
    description:
      'Manage end users who join calls and chats through your application. View participant details and control access for your app’s user base.',
    target: 'tour-nav-participants',
  },
  {
    id: 'nav-agents',
    title: 'Agents',
    description:
      'Configure support or sales agents who handle live conversations. Assign agents so they can join chats and assist your customers.',
    target: 'tour-nav-agents',
  },
  {
    id: 'nav-chatbot',
    title: 'Chat Bot',
    description:
      'Create and update automated chat bots for FAQs and first-line support. Bots can handle common queries before escalating to a human agent.',
    target: 'tour-nav-chat-bot',
  },
  {
    id: 'nav-recordings',
    title: 'Call Recordings',
    description:
      'Browse and download recorded calls when recording is enabled. Useful for quality review, compliance, and training your team.',
    target: 'tour-nav-call-recordings',
  },
  {
    id: 'nav-docs',
    title: 'Documentation',
    description:
      'Step-by-step guides, SDK samples, and integration references. Start here when embedding Calls or Chat UIKits into your product.',
    target: 'tour-nav-documentation',
  },
  {
    id: 'upgrade-plan',
    title: 'Upgrade Plan',
    description:
      'Unlock PRO features such as Syntalix AI sentiment analytics and higher usage limits. Compare plans and upgrade when your product grows.',
    target: 'tour-upgrade-plan',
  },
  {
    id: 'support-center',
    title: 'Support Center',
    description:
      'Need help? Open a support request or browse help resources. Our team can assist with setup, billing, and technical issues.',
    target: 'tour-support-center',
  },
];
